(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[193],{

/***/ 3664:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _Button_module_sass__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(726);
/* harmony import */ var _Button_module_sass__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_Button_module_sass__WEBPACK_IMPORTED_MODULE_2__);




var Button = function(param) {
    var children = param.children, onClick = param.onClick, type = param.type;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
        className: (_Button_module_sass__WEBPACK_IMPORTED_MODULE_2___default().button),
        onClick: onClick,
        type: type,
        children: children
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Button);
Button.defaultProps = {
    onClick: function() {}
};
Button.propTypes = {
    children: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().any),
    onClick: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().func),
    type: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().string)
};


/***/ }),

/***/ 7158:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _Container_module_sass__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(8172);
/* harmony import */ var _Container_module_sass__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_Container_module_sass__WEBPACK_IMPORTED_MODULE_2__);




var Container = function(param) {
    var children = param.children;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (_Container_module_sass__WEBPACK_IMPORTED_MODULE_2___default().container),
        children: children
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Container);
Container.propTypes = {
    children: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().any)
};


/***/ }),

/***/ 5137:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _components_Container_Container__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(7158);
/* harmony import */ var _SearchInput_SearchInput__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(4837);
/* harmony import */ var _Header_module_sass__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(7342);
/* harmony import */ var _Header_module_sass__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_Header_module_sass__WEBPACK_IMPORTED_MODULE_5__);
/* eslint-disable @next/next/no-img-element */ 





var Header = function() {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), isMenuOpen = ref[0], setIsMenuOpen = ref[1];
    var headerClass = "".concat((_Header_module_sass__WEBPACK_IMPORTED_MODULE_5___default().header), " ").concat(isMenuOpen ? (_Header_module_sass__WEBPACK_IMPORTED_MODULE_5___default().headerOpen) : "");
    var menuClass = "".concat((_Header_module_sass__WEBPACK_IMPORTED_MODULE_5___default().menu), " ").concat(isMenuOpen ? (_Header_module_sass__WEBPACK_IMPORTED_MODULE_5___default().menuOpen) : "");
    var burgerClass = "".concat((_Header_module_sass__WEBPACK_IMPORTED_MODULE_5___default().burgerIcon), " ").concat(isMenuOpen ? (_Header_module_sass__WEBPACK_IMPORTED_MODULE_5___default().open) : "");
    var closeMenu = function() {
        return setIsMenuOpen(false);
    };
    var toggleMenu = function(e) {
        e.preventDefault();
        setIsMenuOpen(function(isOpen) {
            return !isOpen;
        });
    };
    var menuItems = [
        {
            href: "/diary",
            title: "Cake Diary"
        },
        {
            href: "/issues",
            title: "Issues"
        },
        {
            href: "https://vimeo.com/user10253399",
            isExternal: true,
            title: "Cake TV"
        },
        {
            href: "/buy",
            isExternal: true,
            title: "Buy Print + Digital!"
        },
        {
            href: "/merch",
            isExternal: true,
            title: "Merch"
        }, 
    ];
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("header", {
        className: headerClass,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_Container_Container__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
            className: (_Header_module_sass__WEBPACK_IMPORTED_MODULE_5___default().container),
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                    className: (_Header_module_sass__WEBPACK_IMPORTED_MODULE_5___default().logo),
                    href: "/",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                        onClick: closeMenu,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                            children: "Cake Magazine"
                        })
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("nav", {
                    className: (_Header_module_sass__WEBPACK_IMPORTED_MODULE_5___default().menuBar),
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: burgerClass,
                            onClick: toggleMenu,
                            children: [
                                "Menu",
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {}),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {}),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {}),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {})
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: menuClass,
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("ul", {
                                children: [
                                    menuItems.map(function(param) {
                                        var href = param.href, isExternal = param.isExternal, title = param.title;
                                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                            children: isExternal ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                href: href,
                                                onClick: closeMenu,
                                                target: "_blank",
                                                rel: "noreferrer",
                                                children: title
                                            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                                                href: href,
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                    onClick: closeMenu,
                                                    children: title
                                                })
                                            })
                                        }, href);
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                                        className: (_Header_module_sass__WEBPACK_IMPORTED_MODULE_5___default().institutionalLinks),
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                                                href: "/about",
                                                children: "About us"
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                                                href: "/contact",
                                                children: "Contact"
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                                                href: "/cookie-policy",
                                                children: "Cookie Policy"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                        className: (_Header_module_sass__WEBPACK_IMPORTED_MODULE_5___default().search),
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_SearchInput_SearchInput__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {})
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                                        className: (_Header_module_sass__WEBPACK_IMPORTED_MODULE_5___default().socialIcons),
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                "aria-label": "Follow Cake on Instagram",
                                                href: "https://www.instagram.com/cakemagazine",
                                                target: "_blank",
                                                rel: "noopener noreferrer",
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                    alt: "Follow @cakemagazine on Instagram",
                                                    height: 20,
                                                    width: 20,
                                                    src: "/icons/instagram.svg"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                "aria-label": "Follow Cake on Facebook",
                                                href: "https://www.fb.com/cakemag",
                                                target: "_blank",
                                                rel: "noopener noreferrer",
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                    alt: "Follow Cake on Facebook",
                                                    height: 20,
                                                    width: 20,
                                                    src: "/icons/facebook.svg"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                "aria-label": "Follow Cake on Vimeo",
                                                href: "https://vimeo.com/user10253399",
                                                target: "_blank",
                                                rel: "noopener noreferrer",
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                    alt: "Follow Cake on Vimeo",
                                                    height: 20,
                                                    width: 20,
                                                    src: "/icons/vimeo.svg"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                "aria-label": "Follow Cake on Tumblr",
                                                href: "https://cake-mag.tumblr.com",
                                                target: "_blank",
                                                rel: "noopener noreferrer",
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                    alt: "Follow Cake on Tumblr",
                                                    height: 20,
                                                    width: 20,
                                                    src: "/icons/tumblr.svg"
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Header);


/***/ }),

/***/ 4884:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(5697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _PostItem_module_sass__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(7682);
/* harmony import */ var _PostItem_module_sass__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_PostItem_module_sass__WEBPACK_IMPORTED_MODULE_4__);






var PostItem = function(param) {
    var featuredImage = param.featuredImage, index = param.index, slug = param.slug, title = param.title;
    var ref, ref1;
    /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_3___default()), {
        href: "/".concat(slug),
        prefetch: false,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: (_PostItem_module_sass__WEBPACK_IMPORTED_MODULE_4___default().postItem),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: (_PostItem_module_sass__WEBPACK_IMPORTED_MODULE_4___default().overlay),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                            children: title
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: (_PostItem_module_sass__WEBPACK_IMPORTED_MODULE_4___default().image),
                        children: (featuredImage === null || featuredImage === void 0 ? void 0 : (ref = featuredImage.node) === null || ref === void 0 ? void 0 : ref.sourceUrl) ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                            alt: title,
                            height: 500,
                            layout: "responsive",
                            objectFit: "contain",
                            priority: index < 3,
                            src: featuredImage === null || featuredImage === void 0 ? void 0 : (ref1 = featuredImage.node) === null || ref1 === void 0 ? void 0 : ref1.sourceUrl,
                            unoptimized: true,
                            width: 500
                        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: (_PostItem_module_sass__WEBPACK_IMPORTED_MODULE_4___default().fallbackImage),
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                alt: "fallback image",
                                width: "200",
                                src: "/cake-logo.svg"
                            })
                        })
                    })
                ]
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (PostItem);
PostItem.propTypes = {
    featuredImage: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().object),
    index: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().number),
    slug: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().string),
    title: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().string)
};


/***/ }),

/***/ 7290:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Db": function() { return /* binding */ scrollToShowMore; },
/* harmony export */   "Y6": function() { return /* binding */ INITIAL_STATE; },
/* harmony export */   "jO": function() { return /* binding */ postsReducer; },
/* harmony export */   "om": function() { return /* binding */ ACTION; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9396);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9815);



var ACTION = {
    UPDATE_LIST: "UPDATE_LIST"
};
var INITIAL_STATE = function(param) {
    var pageInfo = param.pageInfo, postList = param.postList;
    return {
        cursor: pageInfo === null || pageInfo === void 0 ? void 0 : pageInfo.endCursor,
        hasMore: pageInfo === null || pageInfo === void 0 ? void 0 : pageInfo.hasNextPage,
        postList: postList
    };
};
var postsReducer = function(state, param) {
    var payload = param.payload, type = param.type;
    if (type === ACTION.UPDATE_LIST) {
        var ref, ref1;
        return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, state), {
            cursor: payload === null || payload === void 0 ? void 0 : (ref = payload.pageInfo) === null || ref === void 0 ? void 0 : ref.endCursor,
            hasMore: payload === null || payload === void 0 ? void 0 : (ref1 = payload.pageInfo) === null || ref1 === void 0 ? void 0 : ref1.hasPreviousPage,
            postList: (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(state.postList).concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(payload === null || payload === void 0 ? void 0 : payload.nodes))
        });
    }
};
var scrollToShowMore = function() {
    return window.scrollBy({
        top: window.innerHeight / 2,
        left: 0,
        behavior: "smooth"
    });
};


/***/ }),

/***/ 4837:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _SearchInput_module_sass__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2267);
/* harmony import */ var _SearchInput_module_sass__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_SearchInput_module_sass__WEBPACK_IMPORTED_MODULE_2__);




var SearchInput = function(param) {
    var defaultValue = param.defaultValue;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (_SearchInput_module_sass__WEBPACK_IMPORTED_MODULE_2___default().searchContainer),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("form", {
            action: "/search",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                    autoCapitalize: "off",
                    autoComplete: "off",
                    defaultValue: defaultValue,
                    name: "q",
                    placeholder: "Search",
                    required: true,
                    type: "search"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                    type: "submit",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                        alt: "Search",
                        height: 20,
                        width: 20,
                        src: "/icons/search.svg"
                    })
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (SearchInput);
SearchInput.propTypes = {
    defaultValue: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().string)
};


/***/ }),

/***/ 9699:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "gK": function() { return /* binding */ getPostsQuery; },
/* harmony export */   "uP": function() { return /* binding */ getSearchQuery; }
/* harmony export */ });
/* unused harmony exports getIssues, getIssueQuery, getPostQuery, getContactQuery */
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var _apollo_client__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1621);

function _templateObject() {
    var data = _tagged_template_literal([
        '\n    fragment CoverImage on MediaItem {\n      mediaDetails {\n        width\n        height\n      }\n      altText\n      sourceUrl(size: MEDIUM)\n      title\n    }\n\n    query Issues {\n      categories(\n        where: { orderby: SLUG, nameLike: "issue", order: DESC }\n        first: 100\n      ) {\n        nodes {\n          name\n          slug\n          categoriesExtra {\n            buylink\n            buylinkalternative\n            featureimage {\n              ...CoverImage\n            }\n          }\n          count\n          posts(first: 1) {\n            nodes {\n              slug\n            }\n          }\n        }\n      }\n    }\n  '
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _tagged_template_literal([
        "\n    query IssuePosts($count: Int, $slug: String!) {\n      categories(first: 1, where: { slug: [$slug] }) {\n        nodes {\n          categoriesExtra {\n            buylink\n            buylinkalternative\n            featureimage {\n              sourceUrl\n            }\n            featureimagealternative {\n              sourceUrl\n            }\n          }\n          name\n        }\n      }\n      posts(where: { categoryName: $slug }, first: $count) {\n        nodes {\n          featuredImage {\n            node {\n              sourceUrl(size: _2048X2048)\n            }\n          }\n          id\n          slug\n          title(format: RENDERED)\n          uri\n        }\n        pageInfo {\n          endCursor\n          hasNextPage\n        }\n      }\n    }\n  "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        '\n    query HomePosts($after: String, $count: Int) {\n      posts(\n        after: $after\n        first: $count\n        where: { orderby: { field: DATE, order: DESC } }\n      ) {\n        nodes {\n          id\n          slug\n          title\n          featuredImage {\n            node {\n              sourceUrl\n            }\n          }\n        }\n        pageInfo {\n          hasNextPage\n          hasPreviousPage\n          endCursor\n          startCursor\n        }\n      }\n      categories(\n        where: { order: DESC, orderby: SLUG, nameLike: "issue" }\n        first: 1\n      ) {\n        nodes {\n          categoriesExtra {\n            buylink\n            buylinkalternative\n            featureimage {\n              sourceUrl(size: _2048X2048)\n            }\n          }\n          name\n          posts {\n            nodes {\n              slug\n              title\n            }\n          }\n        }\n      }\n    }\n  '
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _tagged_template_literal([
        "\n    query PostDetail($slug: String!) {\n      postBy(slug: $slug) {\n        categories {\n          nodes {\n            name\n            uri\n          }\n        }\n        content(format: RENDERED)\n        featuredImage {\n          node {\n            altText\n            sourceUrl(size: LARGE)\n          }\n        }\n        id\n        title\n      }\n    }\n  "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    query SearchResults($after: String, $count: Int, $term: String!) {\n      posts(\n        after: $after\n        first: $count\n        where: { orderby: { field: DATE, order: DESC }, search: $term }\n      ) {\n        edges {\n          node {\n            excerpt\n            featuredImage {\n              node {\n                sourceUrl\n              }\n            }\n            id\n            slug\n            title\n            uri\n          }\n        }\n        pageInfo {\n          endCursor\n          startCursor\n          hasNextPage\n        }\n      }\n    }\n  "
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _tagged_template_literal([
        '\n    query ContactPage {\n      pageBy(uri: "/contact-form") {\n        id\n        content(format: RENDERED)\n      }\n    }\n  '
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}

var getIssues = function() {
    return {
        query: gql(_templateObject())
    };
};
var getIssueQuery = function(param) {
    var _count = param.count, count = _count === void 0 ? 48 : _count, slug = param.slug;
    return {
        query: gql(_templateObject1()),
        variables: {
            count: count,
            slug: slug
        }
    };
};
var getPostsQuery = function() {
    var ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, _count = ref.count, count = _count === void 0 ? 1 : _count;
    return {
        query: (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject2()),
        variables: {
            count: count
        }
    };
};
var getPostQuery = function(param) {
    var slug = param.slug;
    return {
        query: gql(_templateObject3()),
        variables: {
            slug: slug
        }
    };
};
var getSearchQuery = function(param) {
    var _after = param.after, after = _after === void 0 ? "" : _after, _count = param.count, count = _count === void 0 ? 48 : _count, term = param.term;
    return {
        query: (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject4()),
        variables: {
            after: after,
            count: count,
            term: term
        }
    };
};
var getContactQuery = function() {
    return {
        query: gql(_templateObject5())
    };
};


/***/ }),

/***/ 726:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"button":"Button_button__q4mEs"};

/***/ }),

/***/ 8172:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"Container_container__jvqQM"};

/***/ }),

/***/ 7342:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"header":"Header_header__c7sEG","headerOpen":"Header_headerOpen__1eT1g","shadow":"Header_shadow__vX_rV","burgerIcon":"Header_burgerIcon__bMu2L","open":"Header_open__5zsqk","menu":"Header_menu__oC7Qi","menuOpen":"Header_menuOpen__xsvrr","search":"Header_search__D2K1q","institutionalLinks":"Header_institutionalLinks__aqwUq","socialIcons":"Header_socialIcons__GHhSJ"};

/***/ }),

/***/ 7682:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"postItem":"PostItem_postItem__FHF4y","image":"PostItem_image__p8mhp","overlay":"PostItem_overlay__Rek4F","fallbackImage":"PostItem_fallbackImage__R9uVf"};

/***/ }),

/***/ 2267:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"searchContainer":"SearchInput_searchContainer__KqjXj"};

/***/ }),

/***/ 3200:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"Home_container__zBkib"};

/***/ })

}]);